import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './i18n';
import { setConsentDefaultDenied } from './analytics/consent';
import { captureUtmFromUrl } from './analytics/utm';

// IMPORTANT : Consent Mode posé AVANT toute init Firebase Analytics.
setConsentDefaultDenied();
captureUtmFromUrl();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();
